export default {
  translation: {
    common: {
      delete: 'Futa',
      deleteModalTitle: 'Je, una uhakika wa kufuta kipengee hiki?',
      ok: 'Ndio',
      cancel: 'Hapana',
      total: 'Jumla',
      rename: 'Badilisha jina',
      name: 'Jina',
      save: 'Hifadhi',
      namePlaceholder: 'Tafadhali ingiza jina',
      next: 'Inayofuata',
      create: 'Unda',
      edit: 'Hariri',
      upload: 'Pakia',
      english: 'Kiingereza',
      swahili: 'Kiswahili',
      portugueseBr: 'Kireno (Brazil)',
      chinese: 'Kichina Rahisi',
      traditionalChinese: 'Kichina cha Jadi',
      language: 'Lugha',
      languageMessage: 'Tafadhali ingiza lugha yako!',
      languagePlaceholder: 'chagua lugha yako',
      copy: 'Nakili',
      copied: 'Imenakiliwa',
      comingSoon: 'Inakuja hivi karibuni',
      download: 'Pakua',
      close: 'Funga',
      preview: 'Hakiki',
      move: 'Hamisha',
      warn: 'Onyo',
      action: 'Kitendo',
      s: 'S',
      pleaseSelect: 'Tafadhali chagua',
      pleaseInput: 'Tafadhali ingiza',
      submit: 'Wasilisha',
      embedIntoSite: 'Pachika kwenye tovuti',
      generateApiKey: 'Tengeneza ufunguo wa API',
      previousPage: 'Iliyotangulia',
      nextPage: 'Inayofuata',
      add: 'Ongeza',
    },
    login: {
      login: 'Ingia',
      signUp: 'Jisajili',
      loginDescription: 'Tunafurahi kukuona tena!',
      registerDescription: 'Tunafurahi kukukaribisha!',
      emailLabel: 'Barua pepe',
      emailPlaceholder: 'Tafadhali ingiza barua pepe',
      passwordLabel: 'Nenosiri',
      passwordPlaceholder: 'Tafadhali ingiza nenosiri',
      rememberMe: 'Nikumbuke',
      signInTip: 'Huna akaunti?',
      signUpTip: 'Tayari una akaunti?',
      nicknameLabel: 'Jina la utani',
      nicknamePlaceholder: 'Tafadhali ingiza jina la utani',
      register: 'Unda akaunti',
      continue: 'Endelea',
      title: 'Anza kujenga wasaidizi wako wenye akili.',
      description:
        'Jisajili bure ili kuchunguza teknolojia bora ya RAG. Unda hifadhidata za maarifa na AI ili kuwezesha biashara yako.',
      review: 'kutoka kwa maoni 500+',
    },
    header: {
      knowledgeBase: 'Hifadhidata ya Maarifa',
      chat: 'Ongea',
      register: 'Jisajili',
      signin: 'Ingia',
      home: 'Nyumbani',
      setting: 'Mipangilio ya mtumiaji',
      logout: 'Toka',
      fileManager: 'Usimamizi wa Faili',
      flow: 'Wakala',
      search: 'Tafuta',
    },
    knowledgeList: {
      welcome: 'Karibu tena',
      description: 'Ni hifadhidata zipi za maarifa utatumia leo?',
      createKnowledgeBase: 'Unda hifadhidata ya maarifa',
      name: 'Jina',
      namePlaceholder: 'Tafadhali ingiza jina!',
      doc: 'Nyaraka',
      searchKnowledgePlaceholder: 'Tafuta',
      noMoreData: 'Hayo ndiyo yote. Hakuna zaidi.',
    },
    knowledgeDetails: {
      dataset: 'Hifadhidata',
      testing: 'Upimaji wa urejeshaji',
      files: 'faili',
      configuration: 'Usanidi',
      knowledgeGraph: 'Grafu ya maarifa',
      name: 'Jina',
      namePlaceholder: 'Tafadhali ingiza jina!',
      doc: 'Nyaraka',
      datasetDescription:
        '😉 Tafadhali subiri faili zako zimalize kuchambuliwa kabla ya kuanza mazungumzo yanayoendeshwa na AI.',
      addFile: 'Ongeza faili',
      searchFiles: 'Tafuta faili zako',
      localFiles: 'Faili za ndani',
      emptyFiles: 'Unda faili tupu',
      webCrawl: 'Utambaaji wa Wavuti',
      chunkNumber: 'Idadi ya Vipande',
      uploadDate: 'Tarehe ya Kupakia',
      chunkMethod: 'Mbinu ya Kupiga Vipande',
      enabled: 'Washa',
      disabled: 'Zima',
      action: 'Kitendo',
      parsingStatus: 'Hali ya Uchambuzi',
      processBeginAt: 'Anza saa',
      processDuration: 'Muda',
      progressMsg: 'Maendeleo',
      testingDescription:
        'Fanya jaribio la urejeshaji ili kuangalia kama RAGFlow inaweza kurejesha maudhui yanayokusudiwa kwa LLM. Ikiwa umebadilisha mipangilio ya chaguo-msingi, kama vile uzito wa ufanano wa maneno muhimu au kizingiti cha ufanano, ili kupata matokeo bora zaidi, fahamu kuwa mabadiliko haya hayatahifadhiwa kiotomatiki. Lazima uyatumie kwenye mipangilio ya msaidizi wako wa mazungumzo au mipangilio ya kipengele cha wakala wa Urejeshaji.',
      similarityThreshold: 'Kizingiti cha ufanano',
      similarityThresholdTip:
        'RAGFlow hutumia ama mchanganyiko wa uzito wa ufanano wa maneno muhimu na uzito wa ufanano wa vekta ya kosini, au mchanganyiko wa uzito wa ufanano wa maneno muhimu na uzito wa alama ya upangaji upya wakati wa urejeshaji. Parameta hii inaweka kizingiti cha ufanano kati ya swali la mtumiaji na vipande. Kipande chochote kilicho na alama ya ufanano chini ya kizingiti hiki kitatolewa kwenye matokeo. Kwa chaguo-msingi, kizingiti kimewekwa kuwa 0.2. Hii inamaanisha kuwa ni vipande vyenye alama ya ufanano wa mseto ya 20 au zaidi ndivyo vitarejeshwa.',
      vectorSimilarityWeight: 'Uzito wa ufanano wa maneno muhimu',
      vectorSimilarityWeightTip:
        'Hii inaweka uzito wa ufanano wa maneno muhimu katika alama ya ufanano wa mseto, ama inayotumika na ufanano wa vekta ya kosini au na alama ya upangaji upya. Jumla ya uzito hizi mbili lazima iwe sawa na 1.0.',
      testText: 'Maandishi ya jaribio',
      testTextPlaceholder: 'Ingiza swali lako hapa!',
      testingLabel: 'Upimaji',
      similarity: 'Ufanano wa mseto',
      termSimilarity: 'Ufanano wa maneno',
      vectorSimilarity: 'Ufanano wa vekta',
      hits: 'Mapigo',
      view: 'Tazama',
      filesSelected: 'Faili zilizochaguliwa',
      upload: 'Pakia',
      run: 'Chambua',
      runningStatus0: 'INASUBIRI',
      runningStatus1: 'INACHAMBUA',
      runningStatus2: 'IMEGHAIRIWA',
      runningStatus3: 'IMEFANIKIWA',
      runningStatus4: 'IMESHINDWA',
      pageRanges: 'Masafa ya Kurasa',
      pageRangesTip:
        'Masafa ya kurasa zinazopaswa kuchambuliwa; kurasa nje ya masafa haya hazitachakatwa.',
      fromPlaceholder: 'kutoka',
      fromMessage: 'Namba ya ukurasa wa kuanzia imekosekana',
      toPlaceholder: 'hadi',
      toMessage: 'Namba ya ukurasa wa mwisho imekosekana (haijajumuishwa)',
      layoutRecognize: 'Kichambua PDF',
      layoutRecognizeTip:
        'Tumia modeli ya kuona kwa uchambuzi wa mpangilio wa PDF ili kutambua kwa ufanisi vichwa vya nyaraka, vitalu vya maandishi, picha, na majedwali. Ikiwa chaguo rahisi kimechaguliwa, ni maandishi wazi katika PDF tu yatakayorejeshwa. Tafadhali kumbuka kuwa chaguo hiki kwa sasa kinafanya kazi TU kwa nyaraka za PDF.',
      taskPageSize: 'Ukubwa wa ukurasa wa kazi',
      taskPageSizeMessage: 'Tafadhali ingiza ukubwa wa ukurasa wa kazi yako!',
      taskPageSizeTip:
        'Wakati wa utambuzi wa mpangilio, faili ya PDF inagawanywa katika vipande na kuchakatwa sambamba ili kuongeza kasi ya uchakataji. Parameta hii inaweka ukubwa wa kila kipande. Ukubwa mkubwa wa kipande hupunguza uwezekano wa kugawanya maandishi yanayoendelea kati ya kurasa.',
      addPage: 'Ongeza ukurasa',
      greaterThan: 'Thamani ya sasa lazima iwe kubwa zaidi kuliko hadi!',
      greaterThanPrevious:
        'Thamani ya sasa lazima iwe kubwa zaidi kuliko hadi iliyotangulia!',
      selectFiles: 'Chagua faili',
      changeSpecificCategory: 'Badilisha kategoria mahususi',
      uploadTitle: 'Buruta na udondoshe faili yako hapa ili kupakia',
      uploadDescription:
        'Inasaidia upakiaji wa faili moja au wa mkupuo. Kwa RAGFlow iliyowekwa ndani: kikomo cha ukubwa wa jumla wa faili kwa kila upakiaji ni 1GB, na kikomo cha upakiaji wa mkupuo ni faili 32. Hakuna kikomo cha jumla ya idadi ya faili kwa kila akaunti. Kwa demo.ragflow.io, kikomo cha ukubwa wa jumla wa faili kwa kila upakiaji ni 10MB, na kila faili isizidi 10MB na upeo wa faili 128 kwa kila akaunti.',
      chunk: 'Kipande',
      bulk: 'Mkupuo',
      cancel: 'Ghairi',
      rerankModel: 'Modeli ya upangaji upya',
      rerankPlaceholder: 'Tafadhali chagua',
      rerankTip:
        'Ikiwa imeachwa wazi, RAGFlow itatumia mchanganyiko wa uzito wa ufanano wa maneno muhimu na uzito wa ufanano wa vekta ya kosini; ikiwa modeli ya upangaji upya imechaguliwa, alama ya uzito wa upangaji upya itachukua nafasi ya uzito wa ufanano wa vekta ya kosini. Tafadhali fahamu kuwa kutumia modeli ya upangaji upya kutaongeza kwa kiasi kikubwa muda wa mfumo kujibu.',
      topK: 'Juu-K',
      topKTip:
        'Inatumika pamoja na modeli ya upangaji upya, mpangilio huu unafafanua idadi ya vipande vya maandishi vitakavyotumwa kwa modeli ya upangaji upya iliyobainishwa.',
      delimiter: 'Kigawanishi cha maandishi',
      delimiterTip:
        'Kigawanishi au kitenganishi kinaweza kuwa na herufi maalum moja au nyingi. Ikiwa ni herufi nyingi, hakikisha zimefungwa katika alama za nukuu za nyuma (`). Kwa mfano, ikiwa unasanidi vigawanishi vyako hivi: \\n`##`;, basi maandishi yako yatatenganishwa kwenye mapumziko ya mstari, alama mbili za reli (##), na nukta-mkato.',
      html4excel: 'Excel hadi HTML',
      html4excelTip:
        'Tumia na mbinu ya kipande cha Jumla. Wakati imezimwa, majedwali ya hesabu (XLSX au XLS(Excel97~2003)) katika hifadhidata ya maarifa yatachambuliwa kuwa jozi za ufunguo-thamani. Wakati imewashwa, yatachambuliwa kuwa majedwali ya HTML, kugawanya kila safu 12 ikiwa jedwali la asili lina zaidi ya safu 12.',
      autoKeywords: 'Maneno muhimu-otomatiki',
      autoKeywordsTip:
        'Toa kiotomatiki maneno muhimu N kwa kila kipande ili kuongeza uwekaji alama wao kwa maswali yanayojumuisha maneno hayo muhimu. Fahamu kuwa tokeni za ziada zitatumiwa na modeli ya mazungumzo iliyobainishwa katika "Mipangilio ya modeli ya mfumo". Unaweza kuangalia au kusasisha maneno muhimu yaliyoongezwa kwa kipande kutoka kwa orodha ya vipande.',
      autoQuestions: 'Maswali-otomatiki',
      autoQuestionsTip:
        'Toa kiotomatiki maswali N kwa kila kipande ili kuongeza uwekaji alama wao kwa maswali yanayojumuisha maswali hayo. Unaweza kuangalia au kusasisha maswali yaliyoongezwa kwa kipande kutoka kwa orodha ya vipande. Kipengele hiki hakitavuruga mchakato wa kupiga vipande ikiwa hitilafu itatokea, isipokuwa inaweza kuongeza matokeo tupu kwa kipande cha asili. Fahamu kuwa tokeni za ziada zitatumiwa na LLM iliyobainishwa katika "Mipangilio ya modeli ya mfumo".',
      redo: 'Je, unataka kufuta vipande {{chunkNum}} vilivyopo?',
      setMetaData: 'Weka Data ya Meta',
      pleaseInputJson: 'Tafadhali ingiza JSON',
      documentMetaTips:
        '<p>Data ya meta iko katika muundo wa Json (haiwezi kutafutwa). Itaongezwa kwenye agizo kwa LLM ikiwa vipande vyovyote vya nyaraka hii vimejumuishwa katika agizo.</p><p>Mifano:</p><b>Data ya meta ni:</b><br><code>{  "Author": "Alex Dowson",  "Date": "2024-11-12"}</code><br><b>Agizo litakuwa:</b><br><p>Nyaraka: the_name_of_document</p><p>Mwandishi: Alex Dowson</p><p>Tarehe: 2024-11-12</p><p>Vipande muhimu kama ifuatavyo:</p><ul><li>  Hapa kuna maudhui ya kipande....</li><li>  Hapa kuna maudhui ya kipande....</li></ul>',
      metaData: 'Data ya meta',
      deleteDocumentConfirmContent:
        'Nyaraka imehusishwa na grafu ya maarifa. Baada ya kufutwa, taarifa za nodi na uhusiano zinazohusiana zitafutwa, lakini grafu haitasasishwa mara moja. Kitendo cha kusasisha grafu kinafanywa wakati wa mchakato wa kuchambua nyaraka mpya inayobeba kazi ya utoaji wa grafu ya maarifa.',
      plainText: 'Rahisi',
      reRankModelWaring: 'Modeli ya upangaji upya inatumia muda mwingi sana.',
    },
    knowledgeConfiguration: {
      titleDescription:
        'Sasisha usanidi wa hifadhidata yako ya maarifa hapa, hasa mbinu ya kupiga vipande.',
      name: 'Jina la hifadhidata ya maarifa',
      photo: 'Picha ya hifadhidata ya maarifa',
      description: 'Maelezo',
      language: 'Lugha ya nyaraka',
      languageMessage: 'Tafadhali ingiza lugha yako!',
      languagePlaceholder: 'Tafadhali ingiza lugha yako!',
      permissions: 'Ruhusa',
      embeddingModel: 'Modeli ya ujumuishaji',
      chunkTokenNumber: 'Ukubwa wa kipande unaopendekezwa',
      chunkTokenNumberMessage:
        'Idadi ya tokeni za kipande kwa maandishi inahitajika',
      embeddingModelTip:
        'Modeli inayogeuza vipande kuwa ujumuishaji. Haiwezi kubadilishwa mara tu hifadhidata ya maarifa ina vipande. Ili kubadili kwenda kwa modeli tofauti ya ujumuishaji, lazima ufute vipande vyote vilivyopo katika hifadhidata ya maarifa.',
      permissionsTip:
        "Ikiwa imewekwa kuwa 'Timu', wanachama wote wa timu yako wataweza kusimamia hifadhidata ya maarifa.",
      chunkTokenNumberTip:
        'Inaweka kama kizingiti cha tokeni kwa kuunda kipande. Sehemu yenye tokeni chache kuliko kizingiti hiki itaunganishwa na sehemu zinazofuata hadi idadi ya tokeni izidi kizingiti, ambapo kipande kinaundwa. Hakuna kipande kipya kinachotengenezwa isipokuwa kigawanishi kinapatikana, hata kama kizingiti kimezidiwa.',
      chunkMethod: 'Mbinu ya kupiga vipande',
      chunkMethodTip: 'Tazama vidokezo upande wa kulia.',
      upload: 'Pakia',
      english: 'Kiingereza',
      chinese: 'Kichina',
      portugueseBr: 'Kireno (Brazil)',
      embeddingModelPlaceholder: 'Tafadhali chagua modeli ya ujumuishaji.',
      chunkMethodPlaceholder: 'Tafadhali chagua mbinu ya kupiga vipande.',
      save: 'Hifadhi',
      me: 'Mimi tu',
      team: 'Timu',
      cancel: 'Ghairi',
      methodTitle: 'Maelezo ya mbinu ya kupiga vipande',
      methodExamples: 'Mifano',
      methodExamplesDescription:
        'Picha za skrini zifuatazo zimetolewa kwa ufafanuzi.',
      dialogueExamplesTitle: 'tazama',
      methodEmpty:
        'Hii itaonyesha ufafanuzi wa kuona wa kategoria za hifadhidata ya maarifa',
      book: '<p>Miundo ya faili inayosupportiwa ni <b>DOCX</b>, <b>PDF</b>, <b>TXT</b>.</p><p>Kwa kila kitabu katika PDF, tafadhali weka <i>masafa ya kurasa</i> ili kuondoa taarifa zisizohitajika na kupunguza muda wa uchambuzi.</p>',
      laws: '<p>Miundo ya faili inayosupportiwa ni <b>DOCX</b>, <b>PDF</b>, <b>TXT</b>.</p><p>Nyaraka za kisheria kwa kawaida hufuata muundo mkali wa kuandika. Tunatumia sifa za maandishi kutambua sehemu ya kugawanya.</p><p>Kipande kina kiwango sawa na "KIFUNGU", kuhakikisha maandishi yote ya juu yanajumuishwa katika kipande.</p>',
      manual:
        '<p>Ni <b>PDF</b> tu inayosupportiwa.</p><p>Tunadhania kuwa mwongozo una muundo wa sehemu wa kihierarkia, ukitumia vichwa vya sehemu vya chini zaidi kama kitengo cha msingi cha kupiga vipande nyaraka. Kwa hivyo, picha na majedwali katika sehemu moja hayatatenganishwa, ambayo inaweza kusababisha ukubwa mkubwa wa vipande.</p>',
      naive:
        '<p>Miundo ya faili inayosupportiwa ni <b>DOCX, XLSX, XLS (Excel97~2003), PPT, PDF, TXT, JPEG, JPG, PNG, TIF, GIF, CSV, JSON, EML, HTML</b>.</p><p>Mbinu hii inapiga vipande faili kwa kutumia mbinu "rahisi": </p><p><li>Tumia modeli ya utambuzi wa kuona kugawanya maandishi katika sehemu ndogo.</li><li>Kisha, unganisha sehemu zinazopakana hadi idadi ya tokeni izidi kizingiti kilichobainishwa na "Idadi ya tokeni za kipande kwa maandishi", ambapo kipande kinaundwa.</li></p>',
      paper:
        '<p>Ni faili ya <b>PDF</b> tu inayosupportiwa.</p><p>Makaratasi yatagawanywa kwa sehemu, kama vile <i>muhtasari, 1.1, 1.2</i>. </p><p>Mbinu hii inawezesha LLM kufanya muhtasari wa karatasi kwa ufanisi zaidi na kutoa majibu zaidi ya kina, yanayoeleweka. Hata hivyo, pia inaongeza muktadha kwa mazungumzo ya AI na kuongeza gharama ya hesabu kwa LLM. Kwa hivyo wakati wa mazungumzo, fikiria kupunguza thamani ya "<b>topN</b>".</p>',
      presentation:
        '<p>Miundo ya faili inayosupportiwa ni <b>PDF</b>, <b>PPTX</b>.</p><p>Kila ukurasa katika slaidi inachukuliwa kama kipande, na picha yake ndogo ya kijionyesho inahifadhiwa.</p><p><i>Mbinu hii ya kupiga vipande inatumika kiotomatiki kwa faili zote za PPT zilizopakiwa, kwa hivyo huhitaji kuibainisha kwa mikono.</i></p>',
      qa: '<p>Mbinu hii ya kupiga vipande inasaidia miundo ya faili ya <b>XLSX</b> na <b>CSV/TXT</b>.</p><li>Ikiwa faili iko katika muundo wa <b>XLSX</b> au <b>XLS (Excel97~2003)</b>, inapaswa kuwa na safu wima mbili bila vichwa: moja kwa maswali na nyingine kwa majibu, na safu wima ya maswali ikitangulia safu wima ya majibu. Karatasi nyingi zinakubalika, mradi safu wima zimeundwa vizuri.</li><li>Ikiwa faili iko katika muundo wa <b>CSV/TXT</b>, lazima iwe na usimbaji wa UTF-8 na TAB kama kigawanishi kutenganisha maswali na majibu.</li><p><i>Mistari ya maandishi ambayo haifuati sheria hapo juu itapuuzwa, na kila jozi ya Q&A itachukuliwa kama kipande tofauti.</i></p>',
      resume:
        '<p>Miundo ya faili inayosupportiwa ni <b>DOCX</b>, <b>PDF</b>, <b>TXT</b>.</p><p>Wasifu wa aina mbalimbali zinachambuliwa na kupangwa katika data iliyoundwa ili kuwezesha utafutaji wa wagombea kwa waajiri.</p>',
      table:
        '<p>Miundo ya faili inayosupportiwa ni <b>XLSX</b> na <b>CSV/TXT</b>.</p><p>Hapa kuna mahitaji ya awali na vidokezo:<ul><li>Kwa faili ya CSV au TXT, kigawanishi kati ya safu wima lazima kiwe <em><b>TAB</b></em>.</li><li>Safu ya kwanza lazima iwe vichwa vya safu wima.</li><li>Vichwa vya safu wima lazima viwe maneno yenye maana ili kusaidia uelewa wa LLM yako. Ni desturi nzuri kuweka visawe pamoja vilivyotenganishwa na mkwaju <i>"/"</i> na kuhesabu thamani kwa kutumia mabano, kwa mfano: <i>"Gender/Sex (male, female)"</i>.<p>Hapa kuna mifano ya vichwa:<ol><li>supplier/vendor<b>"TAB"</b>Color (Yellow, Blue, Brown)<b>"TAB"</b>Sex/Gender (male, female)<b>"TAB"</b>size (M, L, XL, XXL)</li></ol></p></li><li>Kila safu katika jedwali itachukuliwa kama kipande.</li></ul>',
      picture:
        '<p>Faili za picha zinasupportiwa, na usaidizi wa video unakuja hivi karibuni.</p><p>Mbinu hii hutumia modeli ya OCR kutoa maandishi kutoka kwa picha.</p><p>Ikiwa maandishi yaliyotolewa na modeli ya OCR yanaonekana hayatoshi, LLM ya kuona iliyobainishwa itatumika kutoa maelezo ya picha.</p>',
      one: '<p>Miundo ya faili inayosupportiwa ni <b>DOCX, XLSX, XLS (Excel97~2003), PDF, TXT</b>.</p><p>Mbinu hii inachukulia kila nyaraka kwa ujumla wake kama kipande.</p><p>Inatumika wakati unahitaji LLM kufanya muhtasari wa nyaraka nzima, mradi inaweza kushughulikia kiasi hicho cha urefu wa muktadha.</p>',
      knowledgeGraph:
        '<p>Miundo ya faili inayosupportiwa ni <b>DOCX, EXCEL, PPT, IMAGE, PDF, TXT, MD, JSON, EML</b></p><p>Mbinu hii inapiga vipande faili kwa kutumia mbinu "rahisi"/"Jumla". Inagawanya nyaraka katika sehemu na kisha kuunganisha sehemu zinazopakana hadi idadi ya tokeni izidi kizingiti kilichobainishwa na "Idadi ya tokeni za kipande kwa maandishi", ambapo kipande kinaundwa.</p><p>Vipande hiyo kisha vinatolewa kwa LLM ili kutoa vitu na uhusiano kwa grafu ya maarifa na ramani ya akili.</p><p>Hakikisha umeweka <b>Aina za vitu</b>.</p>',
      tag: '<p>Hifadhidata ya maarifa inayotumia mbinu ya "Lebo" ya kupiga vipande inafanya kazi kama seti ya lebo. Hifadhidata zingine za maarifa zinaweza kuitumia kuweka lebo kwa vipande vyao, na maswali kwa hifadhidata hizi pia yatawekwa lebo kwa kutumia seti hii ya lebo.</p><p>Hifadhidata ya maarifa inayotumia "Lebo" kama mbinu ya kupiga vipande <b>HAITAHUSIKA</b> katika mchakato wa Urejeshaji-Uimarishaji wa Uzalishaji (RAG).</p><p>Kila kipande katika hifadhidata hii ni jozi huru ya maelezo-lebo.</p><p>Miundo ya faili inayosupportiwa ni pamoja na <b>XLSX</b> na <b>CSV/TXT</b>:</p><p>Ikiwa faili iko katika muundo wa <b>XLSX</b>, inapaswa kuwa na safu wima mbili bila vichwa: moja kwa maelezo ya lebo na nyingine kwa majina ya lebo, na safu wima ya Maelezo ikitangulia safu wima ya Lebo. Karatasi nyingi zinakubalika, mradi safu wima zimeundwa vizuri.</p><p>Ikiwa faili iko katika muundo wa <b>CSV/TXT</b>, lazima iwe na usimbaji wa UTF-8 na TAB kama kigawanishi kutenganisha maelezo na lebo.</p><p>Katika safu wima ya Lebo, <b>koma</b> inatumika kutenganisha lebo.</p><i>Mistari ya maandishi ambayo haifuati sheria hapo juu itapuuzwa.</i>',
      useRaptor: 'Tumia RAPTOR kuimarisha urejeshaji',
      useRaptorTip:
        'Uchakataji wa Kidhahania wa Rekursivu kwa Urejeshaji Uliopangwa kwa Mti, tazama https://huggingface.co/papers/2401.18059 kwa maelezo zaidi.',
      prompt: 'Agizo',
      promptTip:
        'Tumia agizo la mfumo kuelezea kazi kwa LLM, bainisha jinsi inapaswa kujibu, na elezea mahitaji mengine mbalimbali. Agizo la mfumo mara nyingi linatumika pamoja na funguo (vigezo), ambavyo hutumika kama data mbalimbali za ingizo kwa LLM. Tumia mkwaju wa mbele "/" au kitufe cha (x) kuonyesha funguo za kutumia.',
      promptMessage: 'Agizo linahitajika',
      promptText:
        'Tafadhali fanya muhtasari wa aya zifuatazo. Kuwa makini na nambari, usibuni mambo. Aya kama ifuatavyo: {cluster_content} Hapo juu ni maudhui unayohitaji kufanya muhtasari.',
      maxToken: 'Tokeni za juu',
      maxTokenTip: 'Idadi ya juu ya tokeni kwa muhtasari.',
      maxTokenMessage: 'Tokeni za juu zinahitajika',
      threshold: 'Kizingiti',
      thresholdTip:
        'Kadri kizingiti kinavyokuwa kikubwa ndivyo klasta zitakavyokuwa chache.',
      thresholdMessage: 'Kizingiti kinahitajika',
      maxCluster: 'Klasta za juu',
      maxClusterTip: 'Idadi ya juu ya klasta.',
      maxClusterMessage: 'Klasta za juu zinahitajika',
      randomSeed: 'Mbegu ya nasibu',
      randomSeedMessage: 'Mbegu ya nasibu inahitajika',
      entityTypes: 'Aina za vitu',
      vietnamese: 'Kivietinamu',
      pageRank: 'Alama ya ukurasa',
      pageRankTip:
        'Unaweza kuteua alama ya juu ya PageRank kwa hifadhidata mahususi za maarifa wakati wa urejeshaji. Alama inayolingana inaongezwa kwa alama za ufanano wa mseto za vipande vilivyorejeshwa kutoka kwa hifadhidata hizi za maarifa, kuongeza uwekaji alama wao. Tazama https://ragflow.io/docs/dev/set_page_rank kwa maelezo.',
      tagName: 'Lebo',
      frequency: 'Mzunguko',
      searchTags: 'Tafuta lebo',
      tagCloud: 'Wingu',
      tagTable: 'Jedwali',
      tagSet: 'Seti za lebo',
      tagSetTip:
        '<p>Chagua moja au hifadhidata nyingi za lebo za maarifa ili kuweka lebo kiotomatiki kwa vipande katika hifadhidata yako ya maarifa. Tazama https://ragflow.io/docs/dev/use_tag_sets kwa maelezo.</p><p>Swali la mtumiaji pia litawekwa lebo kiotomatiki.</p>Kipengele hiki cha kuweka lebo kiotomatiki kinaimarisha urejeshaji kwa kuongeza safu nyingine ya maarifa mahususi ya uwanja kwenye hifadhidata iliyopo.<p>Tofauti kati ya lebo-otomatiki na neno muhimu-otomatiki:</p><ul><li>Hifadhidata ya lebo ni seti iliyofungwa iliyofafanuliwa na mtumiaji, wakati maneno muhimu yaliyotolewa na LLM yanaweza kuchukuliwa kama seti wazi.</li><li>Lazima upakue seti za lebo katika miundo iliyobainishwa kabla ya kuendesha kipengele cha lebo-otomatiki.</li><li>Kipengele cha neno muhimu-otomatiki kinategemea LLM na kinatumia idadi kubwa ya tokeni.</li></ul>',
      topnTags: 'Lebo za Juu-N',
      tags: 'Lebo',
      addTag: 'Ongeza lebo',
      useGraphRag: 'Toa grafu ya maarifa',
      useGraphRagTip:
        'Jenga grafu ya maarifa juu ya vipande vya faili vya hifadhidata ya maarifa ya sasa ili kuimarisha ujibu wa maswali ya hatua nyingi yanayohusisha mantiki iliyonaswa. Tazama https://ragflow.io/docs/dev/construct_knowledge_graph kwa maelezo.',
      graphRagMethod: 'Mbinu',
      graphRagMethodTip:
        'Nyepesi: (Chaguo-msingi) Tumia maagizo yaliyotolewa na github.com/HKUDS/LightRAG kutoa vitu na uhusiano. Chaguo hili linatumia tokeni chache, kumbukumbu ndogo, na rasilimali chache za hesabu.</br>Jumla: Tumia maagizo yaliyotolewa na github.com/microsoft/graphrag kutoa vitu na uhusiano',
      resolution: 'Utatuzi wa vitu',
      resolutionTip:
        'Swichi ya kuondoa vitu yanayojirudia. Wakati imewashwa, LLM itaunganisha vitu vinavyofanana - k.m., "2025" na "mwaka wa 2025", au "IT" na "Teknolojia ya Habari" - ili kujenga grafu sahihi zaidi',
      community: 'Uzalishaji wa ripoti za jamii',
      communityTip:
        'Katika grafu ya maarifa, jamii ni klasta ya vitu vilivyounganishwa na uhusiano. Unaweza kuwa na LLM kuzalisha muhtasari kwa kila jamii, inayojulikana kama ripoti ya jamii. Tazama hapa kwa maelezo zaidi: https://www.microsoft.com/en-us/research/blog/graphrag-improving-global-search-via-dynamic-community-selection/',
      theDocumentBeingParsedCannotBeDeleted:
        'Nyaraka inayochambuliwa haiwezi kufutwa',
    },
    chunk: {
      chunk: 'Kipande',
      bulk: 'Mkupuo',
      selectAll: 'Chagua Zote',
      enabledSelected: 'Wezesha zilizochaguliwa',
      disabledSelected: 'Zima zilizochaguliwa',
      deleteSelected: 'Futa zilizochaguliwa',
      search: 'Tafuta',
      all: 'Zote',
      enabled: 'Zimewezeshwa',
      disabled: 'Zimezimwa',
      keyword: 'Neno muhimu',
      function: 'Kazi',
      chunkMessage: 'Tafadhali ingiza thamani!',
      full: 'Maandishi kamili',
      ellipse: 'Elipsi',
      graph: 'Grafu ya maarifa',
      mind: 'Ramani ya akili',
      question: 'Swali',
      questionTip:
        'Ikiwa kuna maswali yaliyotolewa, ujumuishaji wa kipande utategemea hayo.',
    },
    chat: {
      newConversation: 'Mazungumzo mapya',
      createAssistant: 'Unda Msaidizi',
      startRecording: 'Recodi Sauti',
      upload: 'weka faili',
      assistantSetting: 'Mipangilio ya msaidizi',
      promptEngine: 'Injini ya agizo',
      modelSetting: 'Mipangilio ya modeli',
      chat: 'Ongea',
      newChat: 'Mazungumzo mapya',
      clearChat: 'Futa mazungumzo',
      send: 'Tuma',
      sendPlaceholder: 'Tuma ujumbe kwa msaidizi...',
      chatConfiguration: 'Usanidi wa Mazungumzo',
      chatConfigurationDescription:
        'Sanidi msaidizi wa mazungumzo kwa hifadhidata zako zilizochaguliwa (hifadhidata za maarifa) hapa! 💕',
      assistantName: 'Jina la msaidizi',
      assistantNameMessage: 'Jina la msaidizi linahitajika',
      namePlaceholder: 'k.m. Jarvis wa Wasifu',
      assistantAvatar: 'Picha ya msaidizi',
      language: 'Lugha',
      emptyResponse: 'Jibu tupu',
      emptyResponseTip:
        'Weka hii kama jibu ikiwa hakuna matokeo yanayorejeshwa kutoka kwa hifadhidata za maarifa kwa swali lako, au acha sehemu hii wazi ili kuruhusu LLM kubuni wakati hakuna kinachopatikana.',
      emptyResponseMessage:
        'Jibu tupu litaanzishwa wakati hakuna kinachohusiana kinarejeshwa kutoka kwa hifadhidata za maarifa. Lazima ufute sehemu ya "Jibu tupu" ikiwa hakuna hifadhidata ya maarifa iliyochaguliwa.',
      setAnOpener: 'Salamu ya ufunguzi',
      setAnOpenerInitial:
        'Habari! Mimi ni msaidizi wako, naweza kukusaidia vipi?',
      setAnOpenerTip: 'Weka salamu ya ufunguzi kwa watumiaji.',
      knowledgeBases: 'Hifadhidata za maarifa',
      knowledgeBasesMessage: 'Tafadhali chagua',
      knowledgeBasesTip:
        'Chagua hifadhidata za maarifa za kuhusisha na msaidizi huu wa mazungumzo.',
      system: 'Agizo la mfumo',
      systemInitialValue:
        'Wewe ni msaidizi mwenye akili. Tafadhali fanya muhtasari wa maudhui ya hifadhidata ya maarifa ili kujibu swali. Tafadhali orodhesha data katika hifadhidata ya maarifa na ujibu kwa kina. Wakati maudhui yote ya hifadhidata ya maarifa hayahusiani na swali, jibu lako lazima lijumuishe sentensi "Jibu unalotafuta halipatikani katika hifadhidata ya maarifa!" Majibu yanahitaji kuzingatia historia ya mazungumzo.\nHapa kuna hifadhidata ya maarifa:\n{knowledge}\nHapo juu ni hifadhidata ya maarifa.',
      systemMessage: 'Tafadhali ingiza!',
      systemTip:
        'Maagizo yako au maelekezo kwa LLM, ikiwa ni pamoja na lakini sio tu jukumu lake, urefu unaotakiwa, toni, na lugha ya majibu yake.',
      topN: 'Juu N',
      topNTip:
        'Sio vipande vyote vyenye alama ya ufanano juu ya "kizingiti cha ufanano" vitatumwa kwa LLM. Hii inachagua vipande "Juu N" kutoka kwa vilivyorejeshwa.',
      variable: 'Kigezo',
      variableTip:
        'Ikitumika pamoja na API za usimamizi wa msaidizi wa mazungumzo za RAGFlow, vigezo vinaweza kusaidia kuendeleza mikakati ya agizo la mfumo yenye unyumbufu zaidi. Vigezo vilivyofafanuliwa vitatumika na "Agizo la mfumo" kama sehemu ya maagizo kwa LLM. {knowledge} ni kigezo maalum kilichohifadhiwa kinachowakilisha vipande vilivyorejeshwa kutoka kwa hifadhidata ya maarifa iliyobainishwa, na vigezo vyote vinapaswa kufungwa katika mabano ya kawaida {} katika "Agizo la mfumo". Tazama https://ragflow.io/docs/dev/set_chat_variables kwa maelezo.',
      add: 'Ongeza',
      key: 'Ufunguo',
      optional: 'Hiari',
      operation: 'Operesheni',
      model: 'Modeli',
      modelTip: 'Modeli kubwa ya lugha ya mazungumzo',
      modelMessage: 'Tafadhali chagua!',
      freedom: 'Uhuru',
      improvise: 'Buni',
      precise: 'Sahihi',
      balance: 'Usawa',
      freedomTip:
        'Njia ya mkato kwa mipangilio ya "Joto", "Juu P", "Adhabu ya uwepo", na "Adhabu ya mzunguko", inayoonyesha kiwango cha uhuru wa modeli. Parameta hii ina chaguo tatu: Chagua "Buni" ili kuzalisha majibu yenye ubunifu zaidi; chagua "Sahihi" (chaguo-msingi) ili kuzalisha majibu yenye tahadhari zaidi; "Usawa" ni katikati kati ya "Buni" na "Sahihi".',
      temperature: 'Joto',
      temperatureMessage: 'Joto linahitajika',
      temperatureTip:
        'Parameta hii inadhibiti nasibu ya utabiri wa modeli. Joto la chini linatoa majibu yenye tahadhari zaidi, wakati joto la juu linatoa majibu yenye ubunifu na utofauti zaidi.',
      topP: 'Juu P',
      topPMessage: 'Juu P inahitajika',
      topPTip:
        'Inajulikana pia kama "sampuli ya kiini", parameta hii inaweka kizingiti cha kuchagua seti ndogo ya maneno yanayowezekana zaidi kuchukua sampuli kutoka, kukata yale yasiyowezekana zaidi.',
      presencePenalty: 'Adhabu ya uwepo',
      presencePenaltyMessage: 'Adhabu ya uwepo inahitajika',
      presencePenaltyTip:
        'Hii inazuia modeli kurudia taarifa sawa kwa kuadhibu maneno ambayo tayari yametokea katika mazungumzo.',
      frequencyPenalty: 'Adhabu ya mzunguko',
      frequencyPenaltyMessage: 'Adhabu ya mzunguko inahitajika',
      frequencyPenaltyTip:
        'Sawa na adhabu ya uwepo, hii inapunguza mwelekeo wa modeli kurudia maneno yale yale mara kwa mara.',
      maxTokens: 'Tokeni za juu',
      maxTokensMessage: 'Tokeni za juu zinahitajika',
      maxTokensTip:
        'Hii inaweka urefu wa juu wa matokeo ya modeli, unaopimwa kwa idadi ya tokeni (maneno au vipande vya maneno). Chaguo-msingi ni 512. Ikiwa imezimwa, unaondoa kikomo cha tokeni za juu, kuruhusu modeli kuamua idadi ya tokeni katika majibu yake.',
      maxTokensInvalidMessage:
        'Tafadhali ingiza nambari halali kwa Tokeni za Juu.',
      maxTokensMinMessage: 'Tokeni za Juu haziwezi kuwa chini ya 0.',
      quote: 'Onyesha nukuu',
      quoteTip: 'Kama kuonyesha maandishi ya asili kama marejeleo.',
      selfRag: 'Kujirejesha-RAG',
      selfRagTip: 'Tafadhali rejea: https://huggingface.co/papers/2310.11511',
      overview: 'Kitambulisho cha Mazungumzo',
      pv: 'Idadi ya ujumbe',
      uv: 'Idadi ya watumiaji hai',
      speed: 'Kasi ya utoaji wa tokeni',
      tokens: 'Tumia idadi ya tokeni',
      round: 'Idadi ya Mwingiliano wa Kikao',
      thumbUp: 'kuridhika kwa wateja',
      preview: 'Hakiki',
      embedded: 'Iliyopachikwa',
      serviceApiEndpoint: 'Mwisho wa API ya Huduma',
      apiKey: 'UFUNGUO WA API',
      apiReference: 'Nyaraka za API',
      dateRange: 'Masafa ya Tarehe:',
      backendServiceApi: 'Seva ya API',
      createNewKey: 'Unda ufunguo mpya',
      created: 'Imeundwa',
      action: 'Kitendo',
      embedModalTitle: 'Pachika kwenye tovuti',
      comingSoon: 'Inakuja hivi karibuni',
      fullScreenTitle: 'Pachika Kamili',
      fullScreenDescription:
        'Pachika iframe ifuatayo kwenye tovuti yako katika eneo linalotakiwa',
      partialTitle: 'Pachika Sehemu',
      extensionTitle: 'Kiendelezi cha Chrome',
      tokenError: 'Tafadhali unda ufunguo wa API kwanza.',
      betaError:
        'Tafadhali pata ufunguo wa API wa RAGFlow kutoka ukurasa wa Mipangilio ya Mfumo kwanza.',
      searching: 'inatafuta majibu...',
      parsing: 'Inachambua',
      uploading: 'Inapakia',
      uploadFailed: 'Upakiaji umeshindwa',
      regenerate: 'Zalisha upya',
      read: 'Soma maudhui',
      tts: 'Maandishi hadi hotuba',
      ttsTip:
        'Hakikisha umechagua modeli ya TTS kwenye ukurasa wa Mipangilio kabla ya kuwasha swichi hii ili kucheza maandishi kama sauti.',
      relatedQuestion: 'Swali linalohusiana',
      answerTitle: 'J',
      multiTurn: 'Uboreshaji wa mizunguko mingi',
      multiTurnTip:
        'Hii inaboresha maswali ya mtumiaji kwa kutumia muktadha katika mazungumzo ya mizunguko mingi. Wakati imewashwa, itatumia tokeni za ziada za LLM.',
      howUseId: 'Jinsi ya kutumia kitambulisho cha mazungumzo?',
      description: 'Maelezo ya msaidizi',
      descriptionPlaceholder: 'k.m. Msaidizi wa mazungumzo kwa wasifu.',
      useKnowledgeGraph: 'Tumia grafu ya maarifa',
      useKnowledgeGraphTip:
        'Kama kutumia grafu ya maarifa katika hifadhidata za maarifa zilizobainishwa wakati wa urejeshaji kwa ujibu wa maswali ya hatua nyingi. Wakati imewashwa, hii itahusisha utafutaji wa mara kwa mara kati ya vipande vya vitu, uhusiano, na ripoti za jamii, kuongeza sana muda wa urejeshaji.',
      keyword: 'Uchambuzi wa maneno muhimu',
      keywordTip:
        'Tumia LLM kuchambua maswali ya mtumiaji, toa maneno muhimu ambayo yatasisitizwa wakati wa hesabu ya uhusiano.',
      languageTip:
        'Inaruhusu kuandika upya sentensi kwa lugha iliyobainishwa au inatumia swali la hivi karibuni ikiwa haijachaguliwa.',
      avatarHidden: 'Ficha picha',
      locale: 'Eneo',
      selectLanguage: 'Chagua lugha',
      reasoning: 'Mantiki',
      reasoningTip:
        'Kama kuwezesha mtiririko wa mantiki wakati wa kujibu maswali, kama inavyoonekana katika modeli kama Deepseek-R1 au OpenAI o1. Wakati imewashwa, hii inaruhusu modeli kufikia maarifa ya nje na kushughulikia maswali magumu hatua kwa hatua, kwa kutumia mbinu kama mantiki ya mnyororo-wa-mawazo. Mbinu hii inaboresha uwezo wa modeli kutoa majibu sahihi kwa kugawanya matatizo katika hatua zinazoweza kudhibitiwa, kuboresha utendaji kwenye kazi zinazohitaji mantiki ya kiakili na fikra za hatua nyingi.',
      tavilyApiKeyTip:
        'Ikiwa ufunguo wa API umewekwa vizuri hapa, utafutaji wa wavuti unaotegemea Tavily utatumika kuongeza urejeshaji wa hifadhidata ya maarifa.',
      tavilyApiKeyMessage: 'Tafadhali ingiza Ufunguo wako wa API wa Tavily',
      tavilyApiKeyHelp: 'Jinsi ya kuipata?',
    },
    message: {
      registered: 'Umesajiliwa!',
      logout: 'Toka',
      logged: 'Umeingia!',
      pleaseSelectChunk: 'Tafadhali chagua kipande!',
      registerDisabled: 'Usajili wa mtumiaji umezimwa',
      modified: 'Imebadilishwa',
      created: 'Imeundwa',
      deleted: 'Imefutwa',
      renamed: 'Imebadilishwa jina',
      operated: 'Imeendeshwa',
      updated: 'Imesasishwa',
      uploaded: 'Imepakiwa',
      200: 'Seva imerudisha data iliyoombwa kwa mafanikio.',
      201: 'Unda au badilisha data kwa mafanikio.',
      202: 'Ombi limewekwa kwenye foleni katika usuli (kazi ya asynchronous).',
      204: 'Data imefutwa kwa mafanikio.',
      400: 'Kulikuwa na hitilafu katika ombi lililotolewa, na seva haikuunda au kubadilisha data.',
      401: 'Tafadhali ingia tena.',
      403: 'Mtumiaji ameruhusiwa, lakini ufikiaji umezuiliwa.',
      404: 'Ombi lilifanywa kwa rekodi ambayo haipo, na seva haikutekeleza operesheni.',
      406: 'Muundo ulioombwa haupatikani.',
      410: 'Rasilimali iliyoombwa imefutwa kabisa na haitapatikana tena.',
      413: 'Ukubwa wa jumla wa faili zilizopakiwa kwa wakati mmoja ni mkubwa sana.',
      422: 'Wakati wa kuunda kitu, hitilafu ya uthibitishaji ilitokea.',
      500: 'Hitilafu ya seva imetokea, tafadhali angalia seva.',
      502: 'Hitilafu ya lango.',
      503: 'Huduma haipatikani na seva imezidiwa kwa muda au inapitia matengenezo.',
      504: 'Muda wa lango umekwisha.',
      requestError: 'Hitilafu ya ombi',
      networkAnomalyDescription:
        'Kuna hitilafu katika mtandao wako na huwezi kuunganisha kwa seva.',
      networkAnomaly: 'hitilafu ya mtandao',
      hint: 'dokezo',
    },
    setting: {
      profile: 'Wasifu',
      profileDescription:
        'Sasisha picha yako na maelezo yako ya kibinafsi hapa.',
      maxTokens: 'Tokeni za Juu',
      maxTokensMessage: 'Tokeni za Juu zinahitajika',
      maxTokensTip:
        'Hii inaweka urefu wa juu wa matokeo ya modeli, unaopimwa kwa idadi ya tokeni (maneno au vipande vya maneno). Chaguo-msingi ni 512. Ikiwa imezimwa, unaondoa kikomo cha tokeni za juu, kuruhusu modeli kuamua idadi ya tokeni katika majibu yake.',
      maxTokensInvalidMessage:
        'Tafadhali ingiza nambari halali kwa Tokeni za Juu.',
      maxTokensMinMessage: 'Tokeni za Juu haziwezi kuwa chini ya 0.',
      password: 'Nenosiri',
      passwordDescription:
        'Tafadhali ingiza nenosiri lako la sasa ili kubadilisha nenosiri lako.',
      model: 'Watoa huduma wa modeli',
      modelDescription: 'Sanidi parameta za modeli na UFUNGUO WA API hapa.',
      team: 'Timu',
      system: 'Mfumo',
      logout: 'Toka',
      api: 'API',
      username: 'Jina la mtumiaji',
      usernameMessage: 'Tafadhali ingiza jina lako la mtumiaji!',
      photo: 'Picha yako',
      photoDescription: 'Hii itaonyeshwa kwenye wasifu wako.',
      colorSchema: 'Mpangilio wa rangi',
      colorSchemaMessage: 'Tafadhali chagua mpangilio wako wa rangi!',
      colorSchemaPlaceholder: 'chagua mpangilio wako wa rangi',
      bright: 'Angavu',
      dark: 'Giza',
      timezone: 'Saa za eneo',
      timezoneMessage: 'Tafadhali ingiza saa za eneo lako!',
      timezonePlaceholder: 'chagua saa za eneo lako',
      email: 'Anwani ya barua pepe',
      emailDescription:
        'Mara baada ya kusajiliwa, Barua pepe haiwezi kubadilishwa.',
      currentPassword: 'Nenosiri la sasa',
      currentPasswordMessage: 'Tafadhali ingiza nenosiri lako!',
      newPassword: 'Nenosiri jipya',
      newPasswordMessage: 'Tafadhali ingiza nenosiri lako!',
      newPasswordDescription:
        'Nenosiri lako jipya lazima liwe na zaidi ya herufi 8.',
      confirmPassword: 'Thibitisha nenosiri jipya',
      confirmPasswordMessage: 'Tafadhali thibitisha nenosiri lako!',
      confirmPasswordNonMatchMessage: 'Nenosiri jipya uliloweka halilingani!',
      cancel: 'Ghairi',
      addedModels: 'Modeli zilizoongezwa',
      modelsToBeAdded: 'Modeli zitakazoongezwa',
      addTheModel: 'Ongeza modeli',
      apiKey: 'Ufunguo-wa-API',
      apiKeyMessage:
        'Tafadhali ingiza ufunguo wa API (kwa modeli iliyowekwa ndani, puuza hii).',
      apiKeyTip:
        'Ufunguo wa API unaweza kupatikana kwa kusajili mtoa huduma wa LLM husika.',
      showMoreModels: 'Onyesha modeli zaidi',
      baseUrl: 'URL-ya-Msingi',
      baseUrlTip:
        'Ikiwa ufunguo wako wa API ni kutoka OpenAI, puuza tu. Watoa huduma wengine wa kati watatoa URL hii ya msingi pamoja na ufunguo wa API.',
      modify: 'Badilisha',
      systemModelSettings: 'Weka modeli za chaguo-msingi',
      chatModel: 'Modeli ya mazungumzo',
      chatModelTip:
        'Modeli ya mazungumzo ya chaguo-msingi kwa kila hifadhidata ya maarifa iliyoundwa upya.',
      embeddingModel: 'Modeli ya ujumuishaji',
      embeddingModelTip:
        'Modeli ya ujumuishaji ya chaguo-msingi kwa kila hifadhidata ya maarifa iliyoundwa upya. Ikiwa huwezi kupata modeli ya ujumuishaji kutoka kwa orodha inayoanguka, angalia kama unatumia toleo dogo la RAGFlow (ambalo halijumuishi modeli za ujumuishaji) au angalia https://ragflow.io/docs/dev/supported_models kuona kama mtoa huduma wako wa modeli anasaidia modeli hii.',
      img2txtModel: 'Modeli ya picha-kwa-maandishi',
      img2txtModelTip:
        'Modeli ya picha-kwa-maandishi ya chaguo-msingi kwa kila hifadhidata ya maarifa iliyoundwa upya. Inaelezea picha au video. Ikiwa huwezi kupata modeli kutoka kwa orodha inayoanguka, angalia https://ragflow.io/docs/dev/supported_models kuona kama mtoa huduma wako wa modeli anasaidia modeli hii.',
      sequence2txtModel: 'Modeli ya hotuba-kwa-maandishi',
      sequence2txtModelTip:
        'Modeli ya ASR ya chaguo-msingi kwa kila hifadhidata ya maarifa iliyoundwa upya. Tumia modeli hii kutafsiri sauti kuwa maandishi yanayolingana.',
      rerankModel: 'Modeli ya upangaji upya',
      rerankModelTip:
        'Modeli ya upangaji upya ya chaguo-msingi kwa upangaji upya wa vipande. Ikiwa huwezi kupata modeli kutoka kwa orodha inayoanguka, angalia https://ragflow.io/docs/dev/supported_models kuona kama mtoa huduma wako wa modeli anasaidia modeli hii.',
      ttsModel: 'Modeli ya TTS',
      ttsModelTip:
        'Modeli ya maandishi-kwa-hotuba ya chaguo-msingi. Ikiwa huwezi kupata modeli kutoka kwa orodha inayoanguka, angalia https://ragflow.io/docs/dev/supported_models kuona kama mtoa huduma wako wa modeli anasaidia modeli hii.',
      workspace: 'Eneo la kazi',
      upgrade: 'Boresha',
      addLlmTitle: 'Ongeza LLM',
      modelName: 'Jina la modeli',
      modelID: 'Kitambulisho cha modeli',
      modelUid: 'UID ya modeli',
      modelNameMessage: 'Tafadhali ingiza jina la modeli yako!',
      modelType: 'Aina ya modeli',
      modelTypeMessage: 'Tafadhali ingiza aina ya modeli yako!',
      addLlmBaseUrl: 'URL ya msingi',
      baseUrlNameMessage: 'Tafadhali ingiza URL yako ya msingi!',
      vision: 'Je, inasaidia Kuona?',
      ollamaLink: 'Jinsi ya kuunganisha {{name}}',
      FishAudioLink: 'Jinsi ya kutumia FishAudio',
      TencentCloudLink: 'Jinsi ya kutumia TencentCloud ASR',
      volcModelNameMessage: 'Tafadhali ingiza jina la modeli yako!',
      addEndpointID: 'EndpointID ya modeli',
      endpointIDMessage: 'Tafadhali ingiza EndpointID ya modeli yako',
      addArkApiKey: 'VOLC ARK_API_KEY',
      ArkApiKeyMessage: 'Tafadhali ingiza ARK_API_KEY yako',
      bedrockModelNameMessage: 'Tafadhali ingiza jina la modeli yako!',
      addBedrockEngineAK: 'UFUNGUO WA UFIKIAJI',
      bedrockAKMessage: 'Tafadhali ingiza UFUNGUO WAKO WA UFIKIAJI',
      addBedrockSK: 'UFUNGUO WA SIRI',
      bedrockSKMessage: 'Tafadhali ingiza UFUNGUO WAKO WA SIRI',
      bedrockRegion: 'Eneo la AWS',
      bedrockRegionMessage: 'Tafadhali chagua!',
      'us-east-1': 'Mashariki ya US (Virginia ya Kaskazini)',
      'us-west-2': 'Magharibi ya US (Oregon)',
      'ap-southeast-1': 'Asia Pacific (Singapore)',
      'ap-northeast-1': 'Asia Pacific (Tokyo)',
      'eu-central-1': 'Ulaya (Frankfurt)',
      'us-gov-west-1': 'AWS GovCloud (US-Magharibi)',
      'ap-southeast-2': 'Asia Pacific (Sydney)',
      addHunyuanSID: 'Kitambulisho cha Siri cha Hunyuan',
      HunyuanSIDMessage: 'Tafadhali ingiza Kitambulisho chako cha Siri',
      addHunyuanSK: 'Ufunguo wa Siri wa Hunyuan',
      HunyuanSKMessage: 'Tafadhali ingiza Ufunguo wako wa Siri',
      addTencentCloudSID: 'Kitambulisho cha Siri cha TencentCloud',
      TencentCloudSIDMessage: 'Tafadhali ingiza Kitambulisho chako cha Siri',
      addTencentCloudSK: 'Ufunguo wa Siri wa TencentCloud',
      TencentCloudSKMessage: 'Tafadhali ingiza Ufunguo wako wa Siri',
      SparkModelNameMessage: 'Tafadhali chagua modeli ya Spark',
      addSparkAPIPassword: 'Nenosiri la API ya Spark',
      SparkAPIPasswordMessage: 'tafadhali ingiza Nenosiri lako la API',
      addSparkAPPID: 'Kitambulisho cha APP cha Spark',
      SparkAPPIDMessage: 'tafadhali ingiza Kitambulisho chako cha APP',
      addSparkAPISecret: 'Siri ya API ya Spark',
      SparkAPISecretMessage: 'tafadhali ingiza Siri yako ya API',
      addSparkAPIKey: 'Ufunguo wa API ya Spark',
      SparkAPIKeyMessage: 'tafadhali ingiza Ufunguo wako wa API',
      yiyanModelNameMessage: 'Tafadhali ingiza jina la modeli',
      addyiyanAK: 'UFUNGUO WA API wa yiyan',
      yiyanAKMessage: 'Tafadhali ingiza UFUNGUO WAKO WA API',
      addyiyanSK: 'UFUNGUO WA SIRI wa yiyan',
      yiyanSKMessage: 'Tafadhali ingiza UFUNGUO WAKO WA SIRI',
      FishAudioModelNameMessage:
        'Tafadhali ipe modeli yako ya usanidi wa hotuba jina',
      addFishAudioAK: 'UFUNGUO WA API wa Fish Audio',
      addFishAudioAKMessage: 'Tafadhali ingiza UFUNGUO WAKO WA API',
      addFishAudioRefID: 'Kitambulisho cha Marejeleo cha FishAudio',
      addFishAudioRefIDMessage:
        'Tafadhali ingiza Kitambulisho cha Marejeleo (acha wazi kutumia modeli ya chaguo-msingi).',
      GoogleModelIDMessage: 'Tafadhali ingiza kitambulisho cha modeli yako!',
      addGoogleProjectID: 'Kitambulisho cha Mradi',
      GoogleProjectIDMessage: 'Tafadhali ingiza Kitambulisho chako cha Mradi',
      addGoogleServiceAccountKey:
        'Ufunguo wa Akaunti ya Huduma (Acha wazi ikiwa unatumia Hati Tambulishi za Chaguo-Msingi za Programu)',
      GoogleServiceAccountKeyMessage:
        'Tafadhali ingiza Ufunguo wa Akaunti ya Huduma ya Google Cloud katika muundo wa base64',
      addGoogleRegion: 'Eneo la Google Cloud',
      GoogleRegionMessage: 'Tafadhali ingiza Eneo la Google Cloud',
      modelProvidersWarn:
        'Tafadhali ongeza modeli ya ujumuishaji na LLM katika <b>Mipangilio > Watoa huduma wa modeli</b> kwanza. Kisha, ziweke katika "Mipangilio ya modeli ya mfumo".',
      apiVersion: 'Toleo-la-API',
      apiVersionMessage: 'Tafadhali ingiza toleo la API',
      add: 'Ongeza',
      updateDate: 'Tarehe ya Kusasisha',
      role: 'Jukumu',
      nickname: 'Jina la utani',
      update: 'Sasisha',
      updateUser: 'Sasisha mtumiaji',
      confirmUpdateMessage: 'Una uhakika unataka kusasisha mtumiaji huyu kuwa',
      delete: 'Futa',
      promote: 'Kuinua Nafasi',
      demote: 'Punguza Nafasi',
      lastLogin: 'Ingia mara ya mwisho',
      invite: 'Alika',
      agree: 'Kubali',
      refuse: 'Kataa',
      teamMembers: 'Wanachama wa Timu',
      joinedTeams: 'Timu Ulizojiunga',
      sureDelete: 'Je, una uhakika wa kuondoa mwanachama huyu?',
      quit: 'Toka',
      sureQuit: 'Je, una uhakika unataka kutoka kwenye timu uliyojiunga?',
      secretKey: 'Ufunguo wa siri',
      publicKey: 'Ufunguo wa umma',
      secretKeyMessage: 'Tafadhali ingiza ufunguo wa siri',
      publicKeyMessage: 'Tafadhali ingiza ufunguo wa umma',
      hostMessage: 'Tafadhali ingiza mwenyeji',
      configuration: 'Usanidi',
      langfuseDescription:
        'Ufuatiliaji, tathmini, usimamizi wa agizo na vipimo ili kurekebisha na kuboresha programu yako ya LLM.',
      viewLangfuseSDocumentation: 'Tazama nyaraka za Langfuse',
      view: 'Tazama',
      modelsToBeAddedTooltip:
        'Ikiwa mtoa huduma wako wa modeli haujaorodheshwa lakini anadai kuwa "analingana na OpenAI", chagua kadi ya OpenAI-API-compatible ili kuongeza modeli husika.',
      institutions: 'Taasisi',
      institutionsManagement: 'Usimamizi wa Taasisi',
      addInstitution: 'Ongeza Taasisi',
      editInstitution: 'Hariri Taasisi',
      institutionName: 'Jina la Taasisi',
      institutionNameRequired: 'Jina la taasisi linahitajika',
      institutionNameMaxLength: 'Jina la taasisi haliwezi kuzidi herufi 255',
      enterInstitutionName: 'Tafadhali ingiza jina la taasisi',
      description: 'Maelezo',
      enterDescription: 'Tafadhali ingiza maelezo',
    },
    fileManager: {
      name: 'Jina',
      uploadDate: 'Tarehe ya Kupakia',
      knowledgeBase: 'Hifadhidata ya Maarifa',
      size: 'Ukubwa',
      action: 'Kitendo',
      addToKnowledge: 'Unganisha na Hifadhidata ya Maarifa',
      pleaseSelect: 'Tafadhali chagua',
      newFolder: 'Folda Mpya',
      file: 'Faili',
      uploadFile: 'Pakia Faili',
      parseOnCreation: 'Chambua wakati wa kuunda',
      directory: 'Saraka',
      uploadTitle: 'Buruta na udondoshe faili yako hapa ili kupakia',
      uploadDescription:
        'Inasaidia upakiaji wa faili moja au wa mkupuo. Kwa RAGFlow iliyowekwa ndani: kikomo cha ukubwa wa jumla wa faili kwa kila upakiaji ni 1GB, na kikomo cha upakiaji wa mkupuo ni faili 32. Hakuna kikomo cha jumla ya idadi ya faili kwa kila akaunti. Kwa demo.ragflow.io, kikomo cha ukubwa wa jumla wa faili kwa kila upakiaji ni 10MB, na kila faili isizidi 10MB na upeo wa faili 128 kwa kila akaunti.',
      local: 'Upakiaji wa ndani',
      s3: 'Upakiaji wa S3',
      preview: 'Hakiki',
      fileError: 'Hitilafu ya faili',
      uploadLimit:
        'Kila faili lazima isizidi 10MB, na jumla ya idadi ya faili lazima isizidi 128.',
      destinationFolder: 'Folda ya marudio',
    },
    flow: {
      cite: 'Nukuu',
      citeTip: 'dokezo la nukuu',
      name: 'Jina',
      nameMessage: 'Tafadhali ingiza jina',
      description: 'Maelezo',
      examples: 'Mifano',
      to: 'Kwa',
      msg: 'Ujumbe',
      messagePlaceholder: 'ujumbe',
      messageMsg: 'Tafadhali ingiza ujumbe au futa sehemu hii.',
      addField: 'Ongeza chaguo',
      addMessage: 'Ongeza ujumbe',
      loop: 'Mzunguko',
      loopTip:
        'Mzunguko ni kikomo cha juu cha idadi ya mizunguko ya kipengele cha sasa, wakati idadi ya mizunguko inazidi thamani ya mzunguko, inamaanisha kuwa kipengele hakiwezi kukamilisha kazi ya sasa, tafadhali boresha wakala upya',
      yes: 'Ndio',
      no: 'Hapana',
      key: 'Ufunguo',
      componentId: 'Kitambulisho cha Kipengele',
      add: 'Ongeza',
      operation: 'operesheni',
      run: 'Endesha',
      save: 'Hifadhi',
      title: 'Kitambulisho:',
      beginDescription: 'Hapa ndipo mtiririko unaanza.',
      answerDescription:
        'Kipengele kinachotumika kama kiungo kati ya binadamu na roboti, kupokea maingizo ya mtumiaji na kuonyesha majibu ya wakala.',
      retrievalDescription:
        'Kipengele kinachorudisha taarifa kutoka kwa hifadhidata za maarifa zilizobainishwa. Hakikisha kuwa hifadhidata za maarifa unazochagua zinatumia modeli sawa ya ujumuishaji.',
      generateDescription:
        'Kipengele kinachoagiza LLM kuzalisha majibu. Hakikisha agizo limewekwa vizuri.',
      categorizeDescription:
        'Kipengele kinachotumia LLM kuainisha maingizo ya mtumiaji katika kategoria zilizofafanuliwa awali. Hakikisha unabainisha jina, maelezo, na mifano kwa kila kategoria, pamoja na kipengele kinachofuata kinacholingana.',
      relevantDescription:
        'Kipengele kinachotumia LLM kutathmini kama matokeo ya juu yanalingana na swali la hivi karibuni la mtumiaji. Hakikisha unabainisha kipengele kinachofuata kwa kila matokeo ya hukumu.',
      rewriteQuestionDescription:
        'Kipengele kinachoandika upya swali la mtumiaji kutoka kwa kipengele cha Mwingiliano, kulingana na muktadha wa mazungumzo ya awali.',
      messageDescription:
        'Kipengele kinachotuma ujumbe tuli. Ikiwa ujumbe nyingi zimetolewa, kinachagua moja kwa nasibu kutuma. Hakikisha kipengele kinachofuata ni "Mwingiliano", kipengele cha kiungo.',
      keywordDescription:
        'Kipengele kinachorudisha matokeo ya juu N ya utafutaji kutoka kwa maingizo ya mtumiaji. Hakikisha thamani ya TopN imewekwa vizuri kabla ya kutumia.',
      switchDescription:
        'Kipengele kinachotathmini masharti kulingana na matokeo ya vipengele vilivyotangulia na kuelekeza mtiririko wa utekelezaji ipasavyo. Inaruhusu mantiki ya matawi ngumu kwa kufafanua kesi na kubainisha vitendo kwa kila kesi au kitendo cha chaguo-msingi ikiwa hakuna masharti yanayotimizwa.',
      wikipediaDescription:
        'Kipengele kinachotafuta kutoka wikipedia.org, kwa kutumia TopN kubainisha idadi ya matokeo ya utafutaji. Kinaongeza hifadhidata za maarifa zilizopo.',
      promptText:
        'Tafadhali fanya muhtasari wa aya zifuatazo. Kuwa makini na nambari, usibuni mambo. Aya kama ifuatavyo: {input} Hapo juu ni maudhui unayohitaji kufanya muhtasari.',
      createGraph: 'Unda wakala',
      createFromTemplates: 'Unda kutoka kwa violezo',
      retrieval: 'Urejeshaji',
      generate: 'Zalisha',
      answer: 'Mwingiliano',
      categorize: 'Ainisha',
      relevant: 'Husika',
      rewriteQuestion: 'Andika upya',
      rewrite: 'Andika upya',
      begin: 'Anza',
      message: 'Ujumbe',
      blank: 'Tupu',
      createFromNothing: 'Unda wakala wako kutoka mwanzo',
      addItem: 'Ongeza Kipengee',
      addSubItem: 'Ongeza Kipengee cha Ndani',
      nameRequiredMsg: 'Jina linahitajika',
      nameRepeatedMsg: 'Jina haliwezi kurudiwa',
      keywordExtract: 'Neno muhimu',
      keywordExtractDescription:
        'Kipengele kinachotoa maneno muhimu kutoka kwa swali la mtumiaji, na N ya Juu ikibainisha idadi ya maneno muhimu ya kutoa.',
      baidu: 'Baidu',
      baiduDescription:
        'Kipengele kinachotafuta kutoka baidu.com, kwa kutumia TopN kubainisha idadi ya matokeo ya utafutaji. Kinaongeza hifadhidata za maarifa zilizopo.',
      duckDuckGo: 'DuckDuckGo',
      duckDuckGoDescription:
        'Kipengele kinachotafuta kutoka duckduckgo.com, kinachokuruhusu kubainisha idadi ya matokeo ya utafutaji kwa kutumia TopN. Kinaongeza hifadhidata za maarifa zilizopo.',
      channel: 'Njia',
      channelTip:
        'Fanya utafutaji wa maandishi au habari kwenye maingizo ya kipengele',
      text: 'Maandishi',
      news: 'Habari',
      messageHistoryWindowSize: 'Ukubwa wa dirisha la ujumbe',
      messageHistoryWindowSizeTip:
        'Ukubwa wa dirisha la historia ya mazungumzo unaohitajika kuonekana na LLM. Kadri ukubwa unavyoongezeka ndivyo ilivyo bora. Lakini kuwa makini na urefu wa juu wa maudhui wa LLM.',
      wikipedia: 'Wikipedia',
      pubMed: 'PubMed',
      pubMedDescription:
        'Kipengele kinachotafuta kutoka https://pubmed.ncbi.nlm.nih.gov/, kinachokuruhusu kubainisha idadi ya matokeo ya utafutaji kwa kutumia TopN. Kinaongeza hifadhidata za maarifa zilizopo.',
      email: 'Barua pepe',
      emailTip:
        'Barua pepe ni sehemu inayohitajika. Lazima uingize anwani ya barua pepe hapa.',
      arXiv: 'ArXiv',
      arXivDescription:
        'Kipengele kinachotafuta kutoka https://arxiv.org/, kinachokuruhusu kubainisha idadi ya matokeo ya utafutaji kwa kutumia TopN. Kinaongeza hifadhidata za maarifa zilizopo.',
      sortBy: 'Panga kwa',
      submittedDate: 'Tarehe ya kuwasilishwa',
      lastUpdatedDate: 'Tarehe ya kusasishwa mwisho',
      relevance: 'Uhusiano',
      google: 'Google',
      googleDescription:
        'Kipengele kinachotafuta kutoka https://www.google.com/, kinachokuruhusu kubainisha idadi ya matokeo ya utafutaji kwa kutumia TopN. Kinaongeza hifadhidata za maarifa zilizopo. Tafadhali kumbuka kuwa hii inahitaji ufunguo wa API kutoka serpapi.com.',
      bing: 'Bing',
      bingDescription:
        'Kipengele kinachotafuta kutoka https://www.bing.com/, kinachokuruhusu kubainisha idadi ya matokeo ya utafutaji kwa kutumia TopN. Kinaongeza hifadhidata za maarifa zilizopo. Tafadhali kumbuka kuwa hii inahitaji ufunguo wa API kutoka microsoft.com.',
      apiKey: 'UFUNGUO WA API',
      country: 'Nchi na Eneo',
      language: 'Lugha',
      googleScholar: 'Google Scholar',
      googleScholarDescription:
        'Kipengele kinachotafuta https://scholar.google.com/. Unaweza kutumia Juu N kubainisha idadi ya matokeo ya utafutaji.',
      yearLow: 'Mwaka wa chini',
      yearHigh: 'Mwaka wa juu',
      patents: 'Hataza',
      data: 'Data',
      deepL: 'DeepL',
      deepLDescription:
        'Kipengele kinachopata tafsiri zaidi zilizobobea kutoka https://www.deepl.com/.',
      authKey: 'Ufunguo wa uthibitishaji',
      sourceLang: 'Lugha ya chanzo',
      targetLang: 'Lugha lengwa',
      gitHub: 'GitHub',
      gitHubDescription:
        'Kipengele kinachotafuta hazina kutoka https://github.com/. Unaweza kutumia Juu N kubainisha idadi ya matokeo ya utafutaji.',
      baiduFanyi: 'BaiduFanyi',
      baiduFanyiDescription:
        'Kipengele kinachopata tafsiri zilizobobea kutoka https://fanyi.baidu.com/.',
      appid: 'Kitambulisho cha Programu',
      secretKey: 'Ufunguo wa siri',
      domain: 'Uwanja',
      transType: 'Aina ya tafsiri',
      baiduSecretKeyOptions: {
        translate: 'Tafsiri ya jumla',
        fieldtranslate: 'Tafsiri ya uwanja',
      },
      baiduDomainOptions: {
        it: 'Teknolojia ya habari',
        finance: 'Fedha na uchumi',
        machinery: 'Utengenezaji wa mashine',
        senimed: 'Bayotiba',
        novel: 'Fasihi ya mtandaoni',
        academic: 'Karatasi ya kitaaluma',
        aerospace: 'Anga',
        wiki: 'Sayansi za ubinadamu na jamii',
        news: 'Habari na taarifa',
        law: 'Sheria na kanuni',
        contract: 'Mkataba',
      },
      baiduSourceLangOptions: {
        auto: 'Tambua kiotomatiki',
        zh: 'Kichina',
        en: 'Kiingereza',
        yue: 'Kikantoni',
        wyw: 'Kichina cha Kale',
        jp: 'Kijapani',
        kor: 'Kikorea',
        fra: 'Kifaransa',
        spa: 'Kihispania',
        th: 'Kithai',
        ara: 'Kiarabu',
        ru: 'Kirusi',
        pt: 'Kireno',
        de: 'Kijerumani',
        it: 'Kiitaliano',
        el: 'Kigiriki',
        nl: 'Kiholanzi',
        pl: 'Kipolandi',
        bul: 'Kibulgaria',
        est: 'Kiestonia',
        dan: 'Kidenmaki',
        fin: 'Kifini',
        cs: 'Kicheki',
        rom: 'Kiromania',
        slo: 'Kislovenia',
        swe: 'Kiswidi',
        hu: 'Kihungari',
        cht: 'Kichina cha Jadi',
        vie: 'Kivietinamu',
      },
      qWeather: 'QWeather',
      qWeatherDescription:
        'Kipengele kinachopata taarifa za hali ya hewa, kama vile joto na ubora wa hewa, kutoka https://www.qweather.com/.',
      lang: 'Lugha',
      type: 'Aina',
      webApiKey: 'Ufunguo wa API ya wavuti',
      userType: 'Aina ya mtumiaji',
      timePeriod: 'Kipindi cha muda',
      qWeatherLangOptions: {
        zh: 'Kichina Rahisi',
        'zh-hant': 'Kichina cha Jadi',
        en: 'Kiingereza',
        de: 'Kijerumani',
        es: 'Kihispania',
        fr: 'Kifaransa',
        it: 'Kiitaliano',
        ja: 'Kijapani',
        ko: 'Kikorea',
        ru: 'Kirusi',
        hi: 'Kihindi',
        th: 'Kithai',
        ar: 'Kiarabu',
        pt: 'Kireno',
        bn: 'Kibengali',
        ms: 'Kimalesia',
        nl: 'Kiholanzi',
        el: 'Kigiriki',
        la: 'Kilatini',
        sv: 'Kiswidi',
        id: 'Kiindonesia',
        pl: 'Kipolandi',
        tr: 'Kituruki',
        cs: 'Kicheki',
        et: 'Kiestonia',
        vi: 'Kivietinamu',
        fil: 'Kifilipino',
        fi: 'Kifini',
        he: 'Kiebrania',
        is: 'Kiaisilandi',
        nb: 'Kinorwei',
      },
      qWeatherTypeOptions: {
        weather: 'Utabiri wa hali ya hewa',
        indices: 'Kiashiria cha maisha ya hali ya hewa',
        airquality: 'Ubora wa hewa',
      },
      qWeatherUserTypeOptions: {
        free: 'Mwanachama wa bure',
        paid: 'Mwanachama aliyelipia',
      },
      qWeatherTimePeriodOptions: {
        now: 'Sasa',
        '3d': 'Siku 3',
        '7d': 'Siku 7',
        '10d': 'Siku 10',
        '15d': 'Siku 12',
        '30d': 'Siku 30',
      },
      publish: 'API',
      exeSQL: 'ExeSQL',
      exeSQLDescription:
        'Kipengele kinachofanya hojaji za SQL kwenye hifadhidata ya uhusiano, kinachosaidia kuhoji kutoka MySQL, PostgreSQL, au MariaDB.',
      dbType: 'Aina ya Hifadhidata',
      database: 'Hifadhidata',
      username: 'Jina la mtumiaji',
      host: 'Mwenyeji',
      port: 'Mlango',
      password: 'Nenosiri',
      switch: 'Badili',
      logicalOperator: 'Opereta wa mantiki',
      switchOperatorOptions: {
        equal: 'Sawa na',
        notEqual: 'Sio sawa',
        gt: 'Kubwa kuliko',
        ge: 'Kubwa au sawa',
        lt: 'Ndogo kuliko',
        le: 'Ndogo au sawa',
        contains: 'Ina',
        notContains: 'Haina',
        startWith: 'Inaanza na',
        endWith: 'Inaishia na',
        empty: 'Ni tupu',
        notEmpty: 'Sio tupu',
      },
      switchLogicOperatorOptions: {
        and: 'NA',
        or: 'AU',
      },
      operator: 'Opereta',
      value: 'Thamani',
      useTemplate: 'Tumia kiolezo hiki',
      wenCai: 'WenCai',
      queryType: 'Aina ya hojaji',
      wenCaiDescription:
        'Kipengele kinachopata taarifa za kifedha, ikiwa ni pamoja na bei za hisa na habari za ufadhili, kutoka kwa tovuti mbalimbali za kifedha.',
      wenCaiQueryTypeOptions: {
        stock: 'hisa',
        zhishu: 'kiashiria',
        fund: 'mfuko',
        hkstock: 'Hisa za Hong Kong',
        usstock: 'Soko la hisa la Marekani',
        threeboard: 'Soko Jipya la OTC',
        conbond: 'Hati ya Dhamana Inayobadilika',
        insurance: 'bima',
        futures: 'mikataba ya baadaye',
        lccp: 'Ufadhili',
        foreign_exchange: 'Fedha za kigeni',
      },
      akShare: 'AkShare',
      akShareDescription:
        'Kipengele kinachopata habari kuhusu hisa kutoka https://www.eastmoney.com/.',
      yahooFinance: 'YahooFinance',
      yahooFinanceDescription:
        'Kipengele kinachohoji taarifa kuhusu kampuni inayofanya biashara kwa umma kwa kutumia alama yake ya ticker.',
      crawler: 'Kitambaa cha Wavuti',
      crawlerDescription:
        'Kipengele kinachotambaa msimbo wa chanzo wa HTML kutoka kwa URL iliyobainishwa.',
      proxy: 'Wakala',
      crawlerResultOptions: {
        html: 'Html',
        markdown: 'Markdown',
        content: 'Maudhui',
      },
      extractType: 'Aina ya utoaji',
      info: 'Taarifa',
      history: 'Historia',
      financials: 'Fedha',
      balanceSheet: 'Taarifa ya mizania',
      cashFlowStatement: 'Taarifa ya mtiririko wa fedha',
      jin10: 'Jin10',
      jin10Description:
        'Kipengele kinachopata taarifa za kifedha kutoka kwa Jukwaa Wazi la Jin10, ikiwa ni pamoja na masasisho ya habari, kalenda, nukuu, na marejeleo.',
      flashType: 'Aina ya haraka',
      filter: 'Chuja',
      contain: 'Ina',
      calendarType: 'Aina ya kalenda',
      calendarDatashape: 'Umbo la data la kalenda',
      symbolsDatatype: 'Aina ya data ya alama',
      symbolsType: 'Aina ya alama',
      jin10TypeOptions: {
        flash: 'Habari za Haraka',
        calendar: 'Kalenda',
        symbols: 'nukuu',
        news: 'marejeleo',
      },
      jin10FlashTypeOptions: {
        '1': 'Habari za Soko',
        '2': 'Habari za Mikataba ya Baadaye',
        '3': 'Habari za Marekani-Hong Kong',
        '4': 'Habari za Hisa za A',
        '5': 'Habari za Bidhaa na Fedha za Kigeni',
      },
      jin10CalendarTypeOptions: {
        cj: 'Kalenda ya Data za Uchumi Mkuu',
        qh: 'Kalenda ya Mikataba ya Baadaye',
        hk: 'Kalenda ya Soko la Hisa la Hong Kong',
        us: 'Kalenda ya Soko la Hisa la Marekani',
      },
      jin10CalendarDatashapeOptions: {
        data: 'Data',
        event: 'Tukio',
        holiday: 'Likizo',
      },
      jin10SymbolsTypeOptions: {
        GOODS: 'Nukuu za Bidhaa',
        FOREX: 'Nukuu za Fedha za Kigeni',
        FUTURE: 'Nukuu za Soko la Kimataifa',
        CRYPTO: 'Nukuu za Sarafu za Dijitali',
      },
      jin10SymbolsDatatypeOptions: {
        symbols: 'Orodha ya Bidhaa',
        quotes: 'Nukuu za Hivi Karibuni za Soko',
      },
      concentrator: 'Mkusanyaji',
      concentratorDescription:
        'Kipengele kinachopokea matokeo kutoka kwa kipengele cha juu na kuyapitisha kama maingizo kwa vipengele vya chini.',
      tuShare: 'TuShare',
      tuShareDescription:
        'Kipengele kinachopata muhtasari wa habari za kifedha kutoka kwa tovuti kuu za kifedha, kusaidia utafiti wa tasnia na wa kiidadi.',
      tuShareSrcOptions: {
        sina: 'Sina',
        wallstreetcn: 'wallstreetcn',
        '10jqka': 'Mkono wa moja kwa moja',
        eastmoney: 'Eastmoney',
        yuncaijing: 'YUNCAIJING',
        fenghuang: 'FENGHUANG',
        jinrongjie: 'JRJ',
      },
      token: 'Tokeni',
      src: 'Chanzo',
      startDate: 'Tarehe ya kuanza',
      endDate: 'Tarehe ya mwisho',
      keyword: 'Neno muhimu',
      note: 'Kidokezo',
      noteDescription: 'Kidokezo',
      notePlaceholder: 'Tafadhali ingiza kidokezo',
      invoke: 'Ita',
      invokeDescription:
        'Kipengele kinachoweza kuita huduma za mbali, kwa kutumia matokeo ya vipengele vingine au thabiti kama maingizo.',
      url: 'Url',
      method: 'Mbinu',
      timeout: 'Muda wa kusubiri',
      headers: 'Vichwa',
      cleanHtml: 'Safisha HTML',
      cleanHtmlTip:
        'Ikiwa jibu lina muundo wa HTML na ni maudhui ya msingi tu yanayotakiwa, tafadhali washa.',
      reference: 'Marejeleo',
      input: 'Ingizo',
      output: 'Tokeo',
      parameter: 'Parameta',
      howUseId: 'Jinsi ya kutumia kitambulisho cha wakala?',
      content: 'Maudhui',
      operationResults: 'Matokeo ya Operesheni',
      autosaved: 'Imehifadhiwa kiotomatiki',
      optional: 'Hiari',
      pasteFileLink: 'Bandika kiungo cha faili',
      testRun: 'Jaribio la Kuendesha',
      template: 'Kiolezo',
      templateDescription:
        'Kipengele kinachounda muundo wa matokeo ya vipengele vingine. 1. Kinasaidia violezo vya Jinja2, kitabadilisha kwanza ingizo kuwa kitu na kisha kutoa kiolezo, 2. Kwa wakati huo huo kinahifadhi mbinu ya asili ya kutumia {parameter} ubadilishaji wa tungo',
      emailComponent: 'Barua pepe',
      emailDescription: 'Tuma barua pepe kwa anwani iliyobainishwa.',
      smtpServer: 'Seva ya SMTP',
      smtpPort: 'Mlango wa SMTP',
      senderEmail: 'Barua pepe ya Mtumaji',
      authCode: 'Msimbo wa Idhini',
      senderName: 'Jina la Mtumaji',
      toEmail: 'Barua pepe ya Mpokeaji',
      ccEmail: 'Barua pepe ya Nakala',
      emailSubject: 'Mada',
      emailContent: 'Maudhui',
      smtpServerRequired: 'Tafadhali ingiza anwani ya seva ya SMTP',
      senderEmailRequired: 'Tafadhali ingiza barua pepe ya mtumaji',
      authCodeRequired: 'Tafadhali ingiza msimbo wa idhini',
      toEmailRequired: 'Tafadhali ingiza barua pepe ya mpokeaji',
      emailContentRequired: 'Tafadhali ingiza maudhui ya barua pepe',
      emailSentSuccess: 'Barua pepe imetumwa kwa mafanikio',
      emailSentFailed: 'Imeshindwa kutuma barua pepe',
      dynamicParameters: 'Parameta za Kiotomatiki',
      jsonFormatTip:
        'Kipengele cha juu kinapaswa kutoa tungo ya JSON katika muundo ufuatao:',
      toEmailTip: 'to_email: Barua pepe ya mpokeaji (Inahitajika)',
      ccEmailTip: 'cc_email: Barua pepe ya nakala (Hiari)',
      subjectTip: 'subject: Mada ya barua pepe (Hiari)',
      contentTip: 'content: Maudhui ya barua pepe (Hiari)',
      jsonUploadTypeErrorMessage: 'Tafadhali pakia faili ya json',
      jsonUploadContentErrorMessage: 'hitilafu ya faili ya json',
      iteration: 'Mzunguko',
      iterationDescription:
        'Kipengele hiki kwanza kinagawanya ingizo katika safu kwa kutumia "kigawanishi". Kinafanya hatua sawa za operesheni kwenye vipengele katika safu kwa mfululizo hadi matokeo yote yametolewa, ambayo inaweza kueleweka kama mchakataji wa mkupuo wa kazi. Kwa mfano, ndani ya nodi ya mzunguko wa tafsiri ya maandishi marefu, ikiwa maudhui yote yanaingizwa kwenye nodi ya LLM, kikomo cha mazungumzo moja kinaweza kufikiwa. Nodi ya juu inaweza kwanza kugawanya maandishi marefu katika vipande vingi, na kushirikiana na nodi ya mzunguko kufanya tafsiri ya mkupuo kwa kila kipande ili kuepuka kufikia kikomo cha ujumbe wa LLM kwa mazungumzo moja.',
      delimiterTip:
        'Kigawanishi hiki kinatumika kugawanya maandishi ya ingizo katika vipande kadhaa vya maandishi kila kimoja kitakachofanywa kama kipengee cha ingizo cha kila mzunguko.',
      delimiterOptions: {
        comma: 'Koma',
        lineBreak: 'Mapumziko ya mstari',
        tab: 'Tab',
        underline: 'Mstari wa chini',
        diagonal: 'Mkwaju wa mbele',
        minus: 'Dash',
        semicolon: 'Nukta-mkato',
      },
      addVariable: 'Ongeza kigezo',
      variableSettings: 'Mipangilio ya vigezo',
      globalVariables: 'Vigezo vya kimataifa',
      systemPrompt: 'Agizo la mfumo',
      addCategory: 'Ongeza kategoria',
      categoryName: 'Jina la kategoria',
      nextStep: 'Hatua inayofuata',
      variableExtractDescription:
        'Toa taarifa za mtumiaji katika kigezo cha kimataifa katika mazungumzo yote',
      variableExtract: 'Vigezo',
      variables: 'Vigezo',
      variablesTip:
        'Weka kigezo cha ufunguo wa json wazi na thamani tupu. k.m. { "UserCode":"", "NumberPhone":"" }',
      datatype: 'Aina ya MINE ya ombi la HTTP',
      insertVariableTip: 'Ingiza / Weka vigezo',
      historyversion: 'Historia ya toleo',
      filename: 'Jina la faili',
      version: {
        created: 'Imeundwa',
        details: 'Maelezo ya toleo',
        dsl: 'DSL',
        download: 'Pakua',
        version: 'Toleo',
        select: 'Hakuna toleo lililochaguliwa',
      },
      setting: 'Mipangilio',
      settings: {
        agentSetting: 'Mipangilio ya wakala',
        title: 'kichwa',
        description: 'maelezo',
        upload: 'Pakia',
        photo: 'Picha',
        permissions: 'Ruhusa',
        permissionsTip: 'Unaweza kuweka ruhusa za wanachama wa timu hapa.',
        me: 'mimi',
        team: 'Timu',
        users: 'Watumiaji',
        addUser: 'Ongeza mtumiaji',
        userManagement: 'Usimamizi wa watumiaji',
        nicknamePlaceholder: 'Tafadhali ingiza jina la utani',
        emailRequired: 'Barua pepe inahitajika',
        invalidEmail: 'Ingizo si barua pepe sahihi!',
        emailPlaceholder: 'Tafadhali ingiza barua pepe yako',
        passwordRequired: 'Nenosiri linahitajika',
        passwordMinLength: 'Nenosiri lazima liwe na angalau herufi 8!',
        update: 'Sasisha',
        updateUser: 'Sasisha mtumiaji',
        confirmUpdateMessage:
          'Una uhakika unataka kusasisha mtumiaji huyu kuwa',
        promote: 'Badilisha Nafasi',
        nickname: 'Jina la utani',
        email: 'Barua pepe',
        password: 'Nenosiri',
        actions: 'Vitendo',
        delete: 'Futa',
      },
      noMoreData: 'Hakuna data zaidi',
      searchAgentPlaceholder: 'Tafuta wakala',
      footer: {
        profile: 'Haki zote zimehifadhiwa @ React',
      },
      layout: {
        file: 'faili',
        knowledge: 'maarifa',
        chat: 'mazungumzo',
      },
      prompt: 'Agizo',
      promptTip:
        'Tumia agizo la mfumo kuelezea kazi kwa LLM, bainisha jinsi inapaswa kujibu, na elezea mahitaji mengine mbalimbali. Agizo la mfumo mara nyingi linatumika pamoja na funguo (vigezo), ambavyo hutumika kama data mbalimbali za ingizo kwa LLM. Tumia mkwaju wa mbele "/" au kitufe cha (x) kuonyesha funguo za kutumia.',
      promptMessage: 'Agizo linahitajika',
      knowledgeBasesTip:
        'Chagua hifadhidata za maarifa za kuhusisha na msaidizi huu wa mazungumzo, au chagua vigezo vinavyojumuisha vitambulisho vya hifadhidata ya maarifa hapa chini.',
      knowledgeBaseVars: 'Vigezo vya hifadhidata ya maarifa',
    },
  },
};
